document.addEventListener("DOMContentLoaded", function () {
  var selectElements = document.querySelectorAll(
    ".card-product-form .productVariantSelect"
  );

  selectElements.forEach(function (selectElement) {
    var cardForm = selectElement.closest(".card-product-form");
    var singleOptions = cardForm.querySelectorAll(".prod-card-single-valued");

    singleOptions.forEach(function (singleOption) {
      singleOption.addEventListener("click", function () {
        singleOptions.forEach(function (el) {
          el.classList.remove("bzeOptionActive");
        });
        singleOption.classList.add("bzeOptionActive");

        let selectedValue = cardForm.querySelector(
          ".prod-card-custom-selected-data"
        );
        let elData = singleOption.getAttribute("data-value");
        let elId = singleOption.getAttribute("data-id");
        let elPrice = singleOption.getAttribute("data-price");
        let elCompPrice = singleOption.getAttribute("data-compare_at_price");
        let salePrice = cardForm
          .closest(".prodCard")
          .querySelector(".productPrice-item--sale");
        let comparePrice = cardForm
          .closest(".prodCard")
          .querySelector(".productPrice-item--regular");
        // let saveMoney = cardForm.closest(".prodCard").querySelector(".productPrice-item--savemoney");
        let percentageValue = cardForm
          .closest(".prodCard")
          .querySelector(".percentagePrice");

        selectedValue.textContent = elData;
        selectedValue.setAttribute("data-value", elData);
        selectedValue.setAttribute("data-id", elId);
        salePrice.textContent = "₹" + elPrice / 100;
        comparePrice.textContent = "₹" + elCompPrice / 100;

        // let discountPrice = "₹. " + (elCompPrice - elPrice) / 100;
        // saveMoney.textContent = discountPrice;
        let myPercentageValue = ((elCompPrice - elPrice) * 100) / elCompPrice;
        percentageValue.textContent = Math.round(myPercentageValue);

        // update the input value into product form
        let variantId = cardForm.querySelector(".product-variant-id");
        variantId.setAttribute("value", elId);
      });
    });

    selectElements.forEach(function (selectElement) {
  selectElement.addEventListener("click", function () {
    const buttonize = selectElement
      .closest(".card-product-form")
      .querySelector(".mydiv .prod-card-custom-drop-value");
    const alreadyActive =
      buttonize && buttonize.classList.contains("customDropValueActive");

    // Loop through all selectElements to remove the active class from all but the clicked element
    selectElements.forEach(function (el) {
      if (el !== selectElement) { // Skip the current element
        const btn = el
          .closest(".card-product-form")
          .querySelector(".mydiv .prod-card-custom-drop-value");
        if (btn && btn.classList.contains("customDropValueActive")) {
          // console.log("Removing active class from button");
          btn.classList.remove("customDropValueActive");
        }
      }
    });

    // Add the active class to the clicked button if it wasn't already active
    if (buttonize && !alreadyActive) {
      // console.log("Adding active class to buttonize");
      buttonize.classList.add("customDropValueActive");
    }
  });
});

    
    // selectElement.addEventListener("click", function () {
    //   const buttonize = cardForm.querySelector(
    //     ".mydiv .prod-card-custom-drop-value"
    //   );
    //   const alreadyActive =
    //     buttonize && buttonize.classList.contains("customDropValueActive");

    //   selectElements.forEach(function (el) {
    //     const btn = el
    //       .closest(".card-product-form")
    //       .querySelector(".mydiv .prod-card-custom-drop-value");
    //     if (btn) {
    //       btn.classList.remove("customDropValueActive");
    //     }
    //   });

    //   if (buttonize && !alreadyActive) {
    //     buttonize.classList.add("customDropValueActive");
    //   }
    // });
  });
});
